<template>
  <BaseButton class="button-sound-toggle" @click="toggleSoundEnabled">
    <!-- inner div needed for flexbox in button -->
    <div class="button-sound-toggle__inner">
      <span class="button-sound-toggle__label">{{ label }}</span>
      <!-- TODO: animate icon -->
      <componente :is="icon" class="button-sound-toggle__icon" />
    </div>
  </BaseButton>
</template>

<script>
import BaseButton from '../ButtonBase';

import SoundEnabledIcon from '../../assets/icons/sound-enabled.svg?inline';
import SoundDisabledIcon from '../../assets/icons/sound-disabled.svg?inline';

import { soundController, setSoundEnabled } from '../../services/sound';

export default {
  name: 'ButtonSoundToggle',

  components: {
    BaseButton,
    SoundEnabledIcon,
    SoundDisabledIcon,
  },

  computed: {
    soundEnabled: () => soundController.soundEnabled,

    icon() {
      return this.soundEnabled ? SoundEnabledIcon : SoundDisabledIcon;
    },

    label() {
      return this.soundEnabled ? 'Sound off' : 'Sound on';
    },
  },

  methods: {
    toggleSoundEnabled() {
      setSoundEnabled(!this.soundEnabled);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-sound-toggle__inner {
  display: flex;
  padding: 20px;
}

.button-sound-toggle__label {
  @include visually-hidden;
}

$icon-size: 24px;
.button-sound-toggle__icon {
  width: $icon-size;
  height: $icon-size;

  transition: 0.3s ease;
  @include helper__composited-layer();
}

.button-sound-toggle:active .button-sound-toggle__icon {
  transform: scale(0.94);
  opacity: 0.8;
}
</style>
